import { Fragment } from "react";
import YudlButton from "../../components/Button";
import CircleCheck from "../../components/Icons/CircleCheck";
// import { SCREENS } from "../../constants";
// import { useWidth } from "../../hooks/useWidth";
import { useAppSelector } from "../../redux/hooks";

const PlanSection = () => {
    const { user } = useAppSelector(state => state.auth);
    // const { width } = useWidth();
    // const isMobile = width < SCREENS.TABLET;
    return (
        <Fragment>
            <div className="px-lg-5 py-lg-3 my-5">
                <div className="row">
                    <div className="col-md-7 d-flex">
                        <div className="me-3">
                            <CircleCheck variant="curvy" />
                        </div>
                        <div className="d-flex flex-column mb-3">
                            <span className="text-capitalize fw-bold text-theme font-18">
                                {user?.plan} Plan is Active
                            </span>
                            <small className="text-theme">
                                This subscription gives you access to design your landing page UI using AI, host your
                                design prototype on our server.
                            </small>
                        </div>
                    </div>
                    <div className="col-md-5 d-flex justify-content-md-end justify-content-center">
                        <YudlButton children="Upgrade Your Plan" />
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default PlanSection;
